import React from "react";
import { useReveal } from "../hooks/useReveal";

const STEPS = [
  {
    n: "01",
    title: "Identify your moments that matter.",
  },
  {
    n: "02",
    title: "Use Protos consistently for 14 days.",
  },
  {
    n: "03",
    title: "Share honest feedback.",
  },
];

export default function Participate({ onNotify }) {
  const head = useReveal();
  return (
    <section
      id="participate"
      data-testid="participate-section"
      className="section relative"
    >
      <div className="container-x relative z-10">
        <div ref={head} className="reveal max-w-3xl mb-12 lg:mb-16">
          <span className="font-mono text-sm uppercase tracking-[0.3em] text-white/55">
            / 09 — Protocol
          </span>
          <h2
            className="kinetic mt-6"
            style={{ fontSize: "clamp(2.6rem, 6vw, 5.4rem)", lineHeight: 0.95 }}
          >
            <span className="gradient-text">HOW TO PARTICIPATE</span>
            <br />
            <span className="outline-text-blue">IN THE PROTOS 100.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/5 border border-white/5 rounded-2xl overflow-hidden">
          {STEPS.map((s, i) => (
            <StepCell key={i} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function StepCell({ s, i }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`step-${i}`}
      className="reveal bg-[#050608] p-8 lg:p-10 hover:bg-[#070a10] transition-colors duration-500"
    >
      <div
        className="font-display text-7xl lg:text-8xl mb-6"
        style={{ color: "var(--blue-bright)" }}
      >
        {s.n}
      </div>
      <h3 className="font-display text-xl lg:text-2xl uppercase text-white leading-tight">
        {s.title}
      </h3>
    </div>
  );
}
